import { Icon } from '@kinesis/bungle';

// The green "S" scenario badge — ported verbatim from suit's `ScenarioIcon`
// for visual parity with suit's disclosure scenario-selector row. Same shape
// as `ghg-protocol-icon` (a custom-SVG bungle `Icon`).
const ScenarioIcon = () => (
  <Icon type='custom' magnitude='medium'>
    <svg
      width='1024'
      height='1024'
      viewBox='0 0 1024 1024'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clip-path='url(#clip0_3628_581)'>
        <path
          // eslint-disable-next-line max-len
          d='M896 0H128C57.3075 0 0 57.3075 0 128V896C0 966.692 57.3075 1024 128 1024H896C966.692 1024 1024 966.692 1024 896V128C1024 57.3075 966.692 0 896 0Z'
          fill='#4EC76A'
        />
        <path
          // eslint-disable-next-line max-len
          d='M516.8 798.911C387.088 798.911 305.125 736.875 298.733 640.625L298.357 634.609H407.767L408.143 638.369C412.278 678.975 456.268 706.421 519.808 706.421C580.34 706.421 622.073 677.471 622.073 635.737V635.361C622.073 599.644 595.379 579.717 528.079 565.806L470.931 554.15C358.138 531.216 309.637 478.579 309.637 396.24V395.864C309.637 295.103 396.111 228.555 516.424 228.555C643.128 228.555 717.571 295.479 724.715 386.089L725.091 390.977H618.313L617.562 386.465C611.17 347.739 573.572 320.669 516.424 320.669C460.403 321.045 423.182 346.611 423.182 387.217V387.593C423.182 422.935 449.5 443.989 513.416 457.148L570.94 468.804C685.613 492.49 735.618 538.359 735.618 622.954V623.33C735.618 730.859 652.151 798.911 516.8 798.911Z'
          fill='white'
          fill-opacity='0.85'
        />
      </g>
      <defs>
        <clipPath id='clip0_3628_581'>
          <rect width='1024' height='1024' fill='white' />
        </clipPath>
      </defs>
    </svg>
  </Icon>
);

export { ScenarioIcon };
